import { useEffect, useState } from "react";
import styled, { css } from "styled-components";
import { UseUpload } from "src/context/UploadProductContext";

import font from "src/styles/font";
import device from "src/styles/device";
import { checkNotEmpty } from "src/common";

import {
  TextField,
  InputAdornment,
  Stack,
  createFilterOptions,
  Autocomplete,
} from "@mui/material";

import Button from "src/components/core/Button";
const Content = styled.div`
  width: 100%;
  overflow-y: auto;
  flex: 1 1 auto;
  -webkit-overflow-scrolling: touch;

  ::-webkit-scrollbar {
    width: 7px;
    height: 5px;
  }
  /* Track */
  ::-webkit-scrollbar-track {
    background: transparent;
  }
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: var(--grey-color);
    border-radius: 100px;
  }
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: var(--grey-color);
  }
  ::-webkit-scrollbar-corner {
    background: transparent;
  }
`;

const Header = styled.div`
  width: 100%;
  padding: 0 24px;
  /* border-bottom: 10px solid var(--darkwhite-color); */
`;

const WrapperHeader = styled.div`
  width: 100%;
  max-width: 530px;
  margin: 0 auto;
`;

const TextLabel = styled.div`
  font-size: ${font.size.md};
  font-weight: 400;
  color: var(--secondary-color);

  span {
    font-size: ${font.size.md};
    font-weight: 400;
    color: var(--primary-color);
  }

  ${({ groupItem }) =>
    groupItem &&
    css`
      width: 30%;
      flex: 0 0 30%;

      @media ${device.mobileL} {
        width: 28%;
        flex: 0 0 28%;
      }
    `}

  ${({ totalPrice }) =>
    totalPrice &&
    css`
      font-weight: 600;
      text-align: center;
      width: 40%;
      flex: 0 0 40%;

      @media ${device.mobileL} {
        width: 50%;
        flex: 0 0 50%;
      }
    `}
`;

const WrapperTextfield = styled.div`
  /* width: 100%;
  margin: 24px 0; */

  ${({ groupItem }) =>
    groupItem &&
    css`
      width: 40%;
      flex: 0 0 40%;

      @media ${device.mobileL} {
        width: 50%;
        flex: 0 0 50%;
      }
    `}

  .TextField-without-border-radius fieldset {
    border-radius: 24px;
    // text-align: center;
    // background: #fff;
  }
  .TextField-without-border-radius-amount fieldset {
    border-radius: 24px;
    width: 100%;
    text-align: center;
    background: #fff;
  }
  .MuiAutocomplete-root {
    margin: 0;
  }
  .MuiOutlinedInput-input {
    background: #fff;
    padding: 16px;
    text-align: center;
  }
  .MuiInputBase-root-MuiOutlinedInput-root {
    border-radius: 24px;
    background: #fff;
  }
  .MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root {
    border-radius: 24px;
  }

  .MuiTextField-root {
    border-radius: 24px;
  }
  .MuiOutlinedInput-root {
    border-radius: 24px;
  }
  /* .MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-input {
    padding: 7.5px 0
  } */
`;

const DetailSection = styled.div`
  width: 100%;
  max-width: 578px;
  margin: 0 auto;
  padding: 24px;
`;

const DetailGroup = styled.div`
  width: 100%;
  margin-bottom: 24px;
  display: flex;
  align-items: center;

  :last-child {
    margin-bottom: 0;
  }
`;

const ButtonGroup = styled(Stack)`
  flex: 0 0 auto;
  width: 100%;
  /* height: max-content; */
  background-color: #fff;
  z-index: 15;
  padding: 32px 24px;
`;

const AddOther = ({ otherData, onSubmit, onClose }) => {
  const {
    masterdata,
    onCreateExProductButton,
    setDataUpload,
    dataUpload,
    setDataUploadChoice,
  } = UseUpload();
  const { seller_data, unitPrice_data } = masterdata;
  const sellerData = seller_data.map(({ seller }) => seller);
  const [selectedSeller, setSelectedSeller] = useState(null);
  const [selectedUnit, setSelectedUnit] = useState(null);
  const [choiceData, setChoiceData] = useState({
    texture_type: null,
    _id: null,
    name: "",
    group_image: {
      product_display_image: "",
      product_full_image: "",
      product_closeup_image: "",
      product_other1_image: "",
      product_other2_image: "",
      product_other3_image: "",
      product_video: "",
    },
    group_price: {
      is_start_price: false,
      special_price: null,
      start_price: null,
      sample_price: null,
      install_price: null,
      price_per_sq: null,
      price: null,
      unit_price: null,
    },
    is_sample: false,
    start_price: false,
    color: null,
    size: {
      calculate_size: null,
      capacity_size: null,
      sale_unit: null,
      width: null,
      height: null,
      quantity: "size",
      thickness: null,
      unit_capacity: null,
      unit_height: null,
      unit_thickness: null,
      unit_width: null,
    },
  });
  const [selectedOtherData, setSelectedOtherdata] = useState({
    item_code: "",
    item_name: "",
    unit_price: "",
    seller: "",
    price: 0,
  });
  useEffect(() => {
    setDataUploadChoice([choiceData]);
  }, [choiceData, setDataUploadChoice]);

  const handleSeller = (seller) => {
    if (seller) {
      setSelectedSeller(seller);
      const userData = seller_data.find((sd) => sd.seller._id === seller._id);
      const user = userData.user;
      setDataUpload({ ...dataUpload, user_id: { user }, is_public: false });
      setSelectedOtherdata((data) => ({
        ...data,
        seller: seller._id,
      }));
    } else {
      setSelectedSeller(null);
    }
  };
  const handleUnit = (unit) => {
    if (unit) {
      setSelectedUnit(unit);
      // setChoiceData((prev) => ({
      //   ...prev,
      //   group_price: { ...prev?.group_price, unit_price: unit },
      // }));
      setSelectedOtherdata((data) => ({
        ...data,
        unit_price: unit._id,
      }));

      // set default size quantity, calculate size, unit size, etc. for upload product
      if (
        unit?._id === "63c90d859d945fef0df81f60" || // gallon
        unit?._id === "63c90d859d945fef0df81f66" // set
      ) {
        setChoiceData((prev) => ({
          ...prev,
          size: {
            ...prev?.size,
            quantity: "capacity",
            calculate_size: null,
            width: null,
            height: null,
            thickness: null,
            unit_width: null,
            unit_height: null,
            unit_thickness: null,
            sale_unit: null,
          },
          group_price: {
            ...prev?.group_price,
            unit_price: unit,
            price_per_sq: null,
          },
        }));
      } else if (unit?._id === "63c90d859d945fef0df81f64") {
        // litre
        setChoiceData((prev) => ({
          ...prev,
          size: {
            ...prev?.size,
            capacity_size: 1,
            unit_capacity: masterdata?.unitArea_data.find(
              (el) => el._id === "63c90df59d945fef0df81f6d",
            ), // litre.
            quantity: "capacity",
            calculate_size: null,
            width: null,
            height: null,
            thickness: null,
            unit_width: null,
            unit_height: null,
            unit_thickness: null,
            sale_unit: null,
          },
          group_price: {
            ...prev?.group_price,
            unit_price: unit,
            price_per_sq: null,
          },
        }));
      } else {
        let unitUpdated;

        unitUpdated = {
          ...choiceData,
          size: {
            ...choiceData?.size,
            quantity: "size",
            capacity_size: null,
            unit_capacity: null,
            sale_unit: null,
          },
          group_price: {
            ...choiceData?.group_price,
            unit_price: unit,
            price_per_sq: null,
          },
        };

        if (unit?._id === "63c90d859d945fef0df81f5f") {
          // sqm.
          setChoiceData({
            ...unitUpdated,
            size: {
              ...unitUpdated?.size,
              calculate_size: 1,
              width: 1,
              height: 1,
              unit_width: masterdata?.unitArea_data.find(
                (el) => el._id === "63c90d359d945fef0df81f5a",
              ), // m.
              unit_height: masterdata?.unitArea_data.find(
                (el) => el._id === "63c90d359d945fef0df81f5a",
              ), // m.
            },
          });
        } else if (unit?._id === "63c90d859d945fef0df81f67") {
          // sq.ft.
          // dataUp?.size?.calculate_size = 0.0929;
          setChoiceData({
            ...unitUpdated,
            size: {
              ...unitUpdated?.size,
              calculate_size: 0.0929,
            },
          });
        } else if (unit?._id === "63c90d859d945fef0df81f69") {
          // yard
          // dataUp?.size?.calculate_size = 0.836;
          setChoiceData({
            ...unitUpdated,
            size: {
              ...unitUpdated?.size,
              calculate_size: 0.836,
            },
          });
        } else {
          setChoiceData({
            ...unitUpdated,
            size: {
              ...unitUpdated?.size,
              calculate_size: null,
            },
          });
        }
      }
    } else {
      setSelectedUnit(null);
    }
  };
  // const handlechoice= ()
  const createAndAddProduct = async () => {
    try {
      await onCreateExProductButton()
        .then((res) => {
          onSubmit(res.productChoice);
          onClose();
        })
        .catch((err) => console.log("create err:", err));
    } catch (err) {
      console.log("err:", err);
    }
  };

  const filterOptions = createFilterOptions({
    matchFrom: "any",
    limit: 100,
  });
  return (
    <>
      <Content>
        <Header>
          <WrapperHeader>
            <TextLabel groupItem>
              บริษัทผู้ขาย<span>*</span>
            </TextLabel>
            <WrapperTextfield
              style={{
                width: "100%",
                margin: "16px 0",
              }}
            >
              <Autocomplete
                id="search-seller"
                isOptionEqualToValue={(option, value) => {
                  // console.log(option, value)
                  return option._id === value;
                }}
                renderOption={(props, option) => (
                  <li
                    {...props}
                    style={{
                      padding: "8px 24px",
                      ":first-child": {
                        paddingTop: "24px",
                      },
                      ":last-child": {
                        paddingBottom: "24px",
                      },
                    }}
                  >
                    {`${
                      checkNotEmpty(option?.company_name) ||
                      option?.company_name !== ""
                        ? option?.company_name
                        : option?.brand_name
                    }`}
                  </li>
                )}
                options={sellerData}
                value={selectedSeller}
                onChange={(event, newValue) => {
                  handleSeller(newValue);
                }}
                getOptionLabel={(option) => {
                  return `${
                    checkNotEmpty(option?.company_name) ||
                    option?.company_name !== ""
                      ? option?.company_name
                      : option?.brand_name
                  }`;
                }}
                filterOptions={filterOptions}
                sx={{
                  width: "100%",
                  background: "#fff",
                  ".MuiOutlinedInput-root": {
                    paddingLeft: "16px",
                  },
                  ".MuiAutocomplete-option": {
                    p: 3,
                  },
                }}
                renderInput={(params) => (
                  <TextField
                    className="TextField-without-border-radius"
                    {...params}
                    label="ค้นหาจากชื่อแบรนด์/ชื่อบริษัท"
                  />
                )}
              />
            </WrapperTextfield>
            <TextLabel groupItem>
              รหัสสินค้า<span>*</span>
            </TextLabel>
            <WrapperTextfield
              style={{
                width: "100%",
                margin: "16px 0",
              }}
            >
              <TextField
                variant="outlined"
                fullWidth
                sx={{
                  ".MuiOutlinedInput-input": {
                    textAlign: "left",
                  },
                }}
                placeholder="รหัสสินค้า"
                value={selectedOtherData?.item_code}
                onChange={(e) => {
                  setDataUpload({ ...dataUpload, item_code: e.target.value });

                  setSelectedOtherdata((prev) => ({
                    ...prev,
                    item_code: e.target.value,
                  }));
                }}
                error={selectedOtherData?.item_code === ""}
              />
            </WrapperTextfield>
            <TextLabel groupItem>
              ชื่อสินค้า<span>*</span>
            </TextLabel>
            <WrapperTextfield
              style={{
                width: "100%",
                margin: "16px 0",
              }}
            >
              <TextField
                variant="outlined"
                fullWidth
                sx={{
                  ".MuiOutlinedInput-input": {
                    textAlign: "left",
                  },
                }}
                placeholder="ชื่อสินค้า"
                value={selectedOtherData?.item_name}
                onChange={(e) => {
                  setDataUpload({ ...dataUpload, item_name: e.target.value });

                  setSelectedOtherdata((prev) => ({
                    ...prev,
                    item_name: e.target.value,
                  }));
                }}
                error={selectedOtherData?.item_name === ""}
              />
            </WrapperTextfield>
          </WrapperHeader>
        </Header>

        <DetailSection>
          <DetailGroup>
            <TextLabel groupItem>
              ราคา<span>*</span>
            </TextLabel>

            <WrapperTextfield groupItem>
              <TextField
                variant="outlined"
                fullWidth
                sx={{
                  ".MuiOutlinedInput-root": {
                    pl: 0,
                  },
                  ".MuiInputAdornment-root": {
                    position: "absolute",
                    left: "14px",
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">฿</InputAdornment>
                  ),
                }}
                value={selectedOtherData?.price}
                onChange={(e) => {
                  if (e.target.value * 0 === 0)
                    setChoiceData((prev) => ({
                      ...prev,
                      group_price: {
                        ...prev?.group_price,
                        price: parseFloat(e.target.value) || 0,
                      },
                    }));
                  setSelectedOtherdata((prev) => ({
                    ...prev,
                    price: e.target.value,
                  }));
                }}
                onBlur={(e) => {
                  if (e.target.value * 0 === 0)
                    setChoiceData((prev) => ({
                      ...prev,
                      group_price: {
                        ...prev?.group_price,
                        price: parseFloat(e.target.value) || 0,
                      },
                    }));
                  setSelectedOtherdata((prev) => ({
                    ...prev,
                    price: parseFloat(e.target.value) || 0,
                  }));
                }}
                error={selectedOtherData?.price <= 0}
              />
            </WrapperTextfield>
          </DetailGroup>

          <DetailGroup>
            <TextLabel groupItem>
              หน่วย<span>*</span>
            </TextLabel>
            <WrapperTextfield groupItem>
              <Autocomplete
                id="search-unit"
                isOptionEqualToValue={(option, value) => {
                  // console.log(option, value)
                  return option._id === value;
                }}
                renderOption={(props, option) => (
                  <li
                    {...props}
                    style={{
                      padding: "8px 24px",
                      ":first-child": {
                        paddingTop: "24px",
                      },
                      ":last-child": {
                        paddingBottom: "24px",
                      },
                    }}
                  >
                    {`${
                      checkNotEmpty(option?.unit_th) || option?.unit_th !== ""
                        ? option?.unit_th
                        : option?.unit_en
                    }`}
                  </li>
                )}
                options={unitPrice_data}
                value={selectedUnit}
                onChange={(event, newValue) => {
                  handleUnit(newValue);
                }}
                getOptionLabel={(option) => {
                  return `${
                    checkNotEmpty(option?.unit_th) || option?.unit_th !== ""
                      ? option?.unit_th
                      : option?.unit_en
                  }`;
                }}
                filterOptions={filterOptions}
                sx={{
                  width: "100%",
                  background: "#fff",
                  ".MuiOutlinedInput-root": {
                    paddingLeft: "16px",
                  },
                  ".MuiAutocomplete-option": {
                    p: 3,
                  },
                }}
                renderInput={(params) => (
                  <TextField
                    className="TextField-without-border-radius"
                    {...params}
                    label="เลือกหน่วยการขายสินค้า"
                  />
                )}
              />
            </WrapperTextfield>
          </DetailGroup>
        </DetailSection>
      </Content>

      <ButtonGroup justifyContent={"center"} alignItems={"center"}>
        <Button
          variant="contained"
          size="large"
          disabled={
            // selectedOtherData?.item_code === productData?.item_code ||
            // selectedOtherData?.item_name === productData?.item_name ||
            // selectedOtherData?.unit_price === productData?.unit_price ||
            selectedOtherData?.item_code === "" ||
            selectedOtherData?.item_name === "" ||
            selectedOtherData?.unit_price === "" ||
            selectedOtherData?.price === 0
          }
          onClick={() => {
            createAndAddProduct();
          }}
          sx={{
            width: "100%",
            maxWidth: 350,
            borderRadius: 4,
            py: 1.5,
          }}
        >
          สร้างและเพิ่มรายการสินค้า
        </Button>
      </ButtonGroup>
    </>
  );
};

export default AddOther;
